import { render, staticRenderFns } from "./editservice.vue?vue&type=template&id=45339c7a&scoped=true&"
import script from "./editservice.vue?vue&type=script&lang=js&"
export * from "./editservice.vue?vue&type=script&lang=js&"
import style0 from "./editservice.vue?vue&type=style&index=0&id=45339c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45339c7a",
  null
  
)

export default component.exports